import Ivora91 from '../../../media/fasad/Ivora/Ivora 9/Ivora (1).webp'
import Ivora92 from '../../../media/fasad/Ivora/Ivora 9/Ivora (2).webp'
import Ivora93 from '../../../media/fasad/Ivora/Ivora 9/Ivora (3).webp'
import Ivora94 from '../../../media/fasad/Ivora/Ivora 9/Ivora (4).webp'
import Ivora95 from '../../../media/fasad/Ivora/Ivora 9/Ivora (5).webp'
import Ivora96 from '../../../media/fasad/Ivora/Ivora 9/Ivora (6).webp'
import Ivora97 from '../../../media/fasad/Ivora/Ivora 9/Ivora (7).webp'
import Ivora98 from '../../../media/fasad/Ivora/Ivora 9/Ivora (8).webp'
import Ivora99 from '../../../media/fasad/Ivora/Ivora 9/Ivora (9).webp'
import Ivora910 from '../../../media/fasad/Ivora/Ivora 9/Ivora (10).webp'
import Ivora911 from '../../../media/fasad/Ivora/Ivora 9/Ivora (11).webp'
import Ivora912 from '../../../media/fasad/Ivora/Ivora 9/Ivora (12).webp'

const Ivora9images =[
Ivora91,Ivora92,Ivora93,Ivora94,Ivora95,Ivora96,Ivora97,Ivora98,Ivora99,Ivora910,Ivora911,Ivora912
]

export default Ivora9images;